import { render, staticRenderFns } from "./main-navigation.vue?vue&type=template&id=0c881dd5&scoped=true&"
import script from "./main-navigation.ts?vue&type=script&lang=ts&"
export * from "./main-navigation.ts?vue&type=script&lang=ts&"
import style0 from "./main-navigation.scss?vue&type=style&index=0&id=0c881dd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c881dd5",
  null
  
)

component.options.__file = "main-navigation.vue"
export default component.exports